import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function CartItem({ item, value }) {
  const { id, title, img, price, total, count } = item;
  const { increment, decrement, removeItem } = value;

  return (
    <div className="row mb-5 text-capitalize text-center align-items-center">
      <div className="col-10 mx-auto my-2 my-lg-0 col-lg-2">
        <img
          src={img}
          alt={title}
          style={{ width: "5rem", height: "5rem" }}
          className="img-fluid"
        />
      </div>
      <div className="col-10 mx-auto my-2 my-lg-0 col-lg-2">
        <span className="d-lg-none">product : </span>
        {title}
      </div>
      <div className="col-10 mx-auto my-2 my-lg-0 col-lg-2">
        <span className="d-lg-none">price : </span>${price}
      </div>
      <div className="col-10 mx-auto my-2 my-lg-0 col-lg-2">
        <div className="d-flex justify-content-center">
          <button className="btn btn-black mx-1" onClick={() => decrement(id)}>
            -
          </button>
          <span className="btn btn-black mx-1">{count}</span>
          <button className="btn btn-black mx-1" onClick={() => increment(id)}>
            +
          </button>
        </div>
      </div>
      <div className="col-10 mx-auto my-2 my-lg-0 col-lg-2">
        <button onClick={() => removeItem(id)} className="remove-button">
          <FontAwesomeIcon icon={faTrash} className="cart-icon" />
        </button>
      </div>
      <div className="col-10 mx-auto my-2 my-lg-0 col-lg-2">
        <strong>item total : ${total}</strong>
      </div>
    </div>
  );
}

CartItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    img: PropTypes.string,
    price: PropTypes.number,
    total: PropTypes.number,
    count: PropTypes.number
  }).isRequired,
  value: PropTypes.shape({
    increment: PropTypes.func,
    decrement: PropTypes.func,
    removeItem: PropTypes.func,
    clearItem: PropTypes.func
  }).isRequired
};
